/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoForInboundPictureVo } from './OrderInfoForInboundPictureVo';
import {
    OrderInfoForInboundPictureVoFromJSON,
    OrderInfoForInboundPictureVoFromJSONTyped,
    OrderInfoForInboundPictureVoToJSON,
    OrderInfoForInboundPictureVoToJSONTyped,
} from './OrderInfoForInboundPictureVo';

/**
 * 
 * @export
 * @interface ResponseOrderInfoForInboundPictureVo
 */
export interface ResponseOrderInfoForInboundPictureVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderInfoForInboundPictureVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderInfoForInboundPictureVo
     */
    message?: string;
    /**
     * 
     * @type {OrderInfoForInboundPictureVo}
     * @memberof ResponseOrderInfoForInboundPictureVo
     */
    data?: OrderInfoForInboundPictureVo;
}

/**
 * Check if a given object implements the ResponseOrderInfoForInboundPictureVo interface.
 */
export function instanceOfResponseOrderInfoForInboundPictureVo(value: object): value is ResponseOrderInfoForInboundPictureVo {
    return true;
}

export function ResponseOrderInfoForInboundPictureVoFromJSON(json: any): ResponseOrderInfoForInboundPictureVo {
    return ResponseOrderInfoForInboundPictureVoFromJSONTyped(json, false);
}

export function ResponseOrderInfoForInboundPictureVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderInfoForInboundPictureVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderInfoForInboundPictureVoFromJSON(json['data']),
    };
}

export function ResponseOrderInfoForInboundPictureVoToJSON(json: any): ResponseOrderInfoForInboundPictureVo {
    return ResponseOrderInfoForInboundPictureVoToJSONTyped(json, false);
}

export function ResponseOrderInfoForInboundPictureVoToJSONTyped(value?: ResponseOrderInfoForInboundPictureVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderInfoForInboundPictureVoToJSON(value['data']),
    };
}

